import { BarChart } from "@tremor/react"

const SLAReportsCharts = ({ data }) => {
    return (
        <>
            {data.SLAInbound && (
                <BarChart
                    data={data.SLAInbound}
                    dataKey="name"
                    categories={["<10Min", "<20Min", "<30Min", ">30Min", "<15Min", "<25Min", "<35Min", ">35Min", "Total"]}
                    showLegend={false}
                    showYAxis={false}
                    startEndOnly={true}
                    className="-mb-2 mt-8 h-48"
                />
            )}
            {data.SLAOutbound && (
                <BarChart
                    data={data.SLAOutbound}
                    dataKey="name"
                    categories={["<10Min", "<20Min", "<30Min", ">30Min", "<15Min", "<25Min", "<35Min", ">35Min", "Total"]}
                    showLegend={false}
                    showYAxis={false}
                    startEndOnly={true}
                    className="-mb-2 mt-8 h-48"
                />
            )}
            {data.SLACancelledOutbound && (
                <BarChart
                    data={data.SLACancelledOutbound}
                    dataKey="name"
                    categories={["CancelledPreAdvised", "CancelledNonPreAdvised"]}
                    showLegend={false}
                    showYAxis={false}
                    startEndOnly={true}
                    className="-mb-2 mt-8 h-48"
                />
            )}
            {data.SLACancelledInbound && (
                <BarChart
                    data={data.SLACancelledInbound}
                    dataKey="name"
                    categories={["CancelledPreAdvised", "CancelledNonPreAdvised"]}
                    showLegend={false}
                    showYAxis={false}
                    startEndOnly={true}
                    className="-mb-2 mt-8 h-48"
                />
            )}
        </>
    )
}
export default SLAReportsCharts